<!--
 * @Description:瀑布流组件
 * @Author: taoyan
 * @Email: taoyan_work@163.com
 * @Date: 2022-03-16 16:45:37
 * @LastEditTime: 2022-12-24 18:12:31

 **********************
  ***** 注意：如果有影响高度的图片必须给图片添加class="img-banner"********
 * 清空列表数据 this.$refs.waterfall.resetDefaultData()
 * 第一次渲染列表数据，通过调用组件内的方法：this.$refs.waterfall.initData('init',this.dataList)
 * 如果有分页，则使用该行代码 ： this.$refs.waterfall.initData('push',this.copyDataList)
 **********************
 * @itemKey   for循环时绑定的key值的字段名
 * @leftRightGap 左侧列距左侧的距离，默认9
 * @upDownGap两列之间的间距，默认9
 * @clickHander 点击item的整个板块触发的方法
 * @slot作为一个默认插槽曝露，props是List的每一项数据，以props.data.XXXXX取值
-->
<!--
使用示例,---<template scope="props">作为默认插槽对外开放，template中的内容及逻辑自定，
下述template中的代码是以专家视角的瀑布流为例
 <waterfallComponents ref='waterfall' class="water-fall" @clickHander="jumpBjdoctor">
  <template scope="props">
    <div class="info-img" v-lazy:background-image="props.data.imgUrl">
      <img class="play-btn" :src="foodPlay" alt="" />
      <span class="share-btn" @click.stop="$emit('doctorShare', props.data, 'baby')"
        >分享</span
      >
      <div class="play-status">
        <span v-if="props.data.id % 3 == 0">3月9日 15:00</span>
        <span v-if="props.data.id % 3 == 1" class="playing">直播中</span>
        <span v-if="props.data.id % 3 == 2">回放</span>
      </div>
    </div>
    <div class="bottom-content">
      <p class="item-title">
        {{
          props.data.id % 2 == 0
            ? props.data.name + "kalfjlakjfliewifhkjhfkshdjhakhflsldfhdkslhfshdfhk"
            : props.data.name
        }}
      </p>
      <div class="item-tagAndPlaynum" v-if="props.data.tag">
        <span class="item-tag">{{ props.data.tag }}</span>
        <p class="item-playnum">
          <img src="./../../../assets/images/food/browse.png" class="icon" />
          <span>{{ fomatterNum(props.data.playNum) || 0 }}</span>
        </p>
      </div>
      <div class="subscribe" v-if="props.data.id % 3 == 0">
        <img src="./../../../assets/images/food/browse.png" class="icon" />
        <span>预约</span>
      </div>
    </div>
  </template>
</waterfallComponents
-->
<template>
  <div
      ref="waterfallcontent"
      :style="{ height: Math.max(leftHCount, rightHCount) + 'px' }"
      class="water-fall-content"
  >
    <div
        v-for="(item, index) in curList"
        :key="item[itemKey] + '' + index"
        ref="waterFallCol"
        :data-id="index"
        :style="{
        opacity: 0,
      }"
        :class="['water-fall-item', item.jumpType ? 'water-fall-jump': '']"
        @click="$emit('clickHander', item, type, index)"
    >
      <slot :data="item" :index="index"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "waterfall-components",
  props: {
    itemKey: {
      type: String,
      default: "id"
    },
    type: {
      type: String,
      default: ""
    },
    pageMargin: {
      type: Number,
      default: 16,
    },
    leftRightGap: {
      type: Number,
      default: 8,
    },
    // 上下间距
    upDownGap: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      leftHCount: 0, // 左列高度
      rightHCount: 0, // 右列高度
      curList: [],
      curListLen: 0,
      imgloadedCount: 0,
      itemWidth: 167, // 每个item的宽
    };
  },
  mounted() {
  },
  watch: {
    curList: {
      handler(newValue) {
        console.log(newValue, 'newValuenewValue')
      }
    },
    deep: true
  },
  methods: {
    // 初始化数据，type：init代表第一次调用，push表示添加数据到组件中，
    /**
     * 设置数据用来渲染列表数据
     * @param type init,首次调用， push，往当前数据后追加数据
     * @param list 要渲染的列表数据
     */
    initData(type, list) {
      console.log(type, 'type')
      if (list && list.length > 0) {
        type == "init" && this.resetDefaultData();
        this.itemWidth = (document.body.clientWidth - Number(this.pageMargin) * 2 - Number(this.leftRightGap)) / 2;
        // 添加数据到当前数据列表中
        this.curList = (type == "push") && this.curList.concat(list) || list;
        this.$nextTick(() => {
          // 首先判断每个板块的图片是否加载完成
          this.doSort(type == "push" && this.curList.length - list.length || 0);
        });
      } else {
        this.resetDefaultData()
      }
    },
    doSort(startIndex) {
      // console.log(startIndex, "startIndex");
      // nodeList，数据渲染完后的页面元素，，重新对页面元素进行排列
      const nodeList = this.$refs.waterFallCol;
      for (let i = startIndex; i < nodeList.length; i++) {
        nodeList[i].style.width = this.itemWidth + 'px';
        // 每一个元素的宽度，高度+上下间距
        const domHeight = nodeList[i].clientHeight + this.upDownGap;
        // 定义每一个的左定位与上定位
        let condition = this.leftHCount > this.rightHCount; //判断条件，左列高度>右列高度
        let top = Math.min(this.rightHCount, this.leftHCount); // top值取小的
        let left = condition && (this.itemWidth + this.leftRightGap + this.pageMargin) || this.pageMargin;
        // 如果左列高度>右列高度，则累加右列的高度。否则，累加左列的高度
        condition && (this.rightHCount += domHeight) || (this.leftHCount += domHeight);
        // 将计算的定位值给curList
        nodeList[i].style.left = left + 'px';
        nodeList[i].style.top = top + 'px';
        nodeList[i].style.opacity = 1;
        // console.log(i, i == nodeList.length - 1)
        if (i == nodeList.length - 1) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit("styleEnd")
            }, 100)

          })
        }
      }

    },
    // 清空当前设置的定位值，
    resetDefaultData() {
      console.log("resetdata");
      this.leftHCount = 0;
      this.rightHCount = 0;
      this.curList = [];
      this.imgloadedCount = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.water-fall-content {
  position: relative;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 8px;

  > .water-fall-item {
    position: absolute;
    width: 167px;
    padding-bottom: 12px;
    background: #ffffff;
    box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
  }
  > .water-fall-jump{
    padding-bottom: 0!important;
  }
}
</style>